import { render, staticRenderFns } from "./dbp.vue?vue&type=template&id=20dc237e&scoped=true&"
import script from "./dbp.vue?vue&type=script&lang=js&"
export * from "./dbp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dc237e",
  null
  
)

export default component.exports